import { applySpec, prop, pipe } from 'ramda';

/** @enum */
export const Contract = {
	ID: 'ID',
	NAME: 'NAME',
	STATUS: 'STATUS',
	BRAND: 'BRAND',
	MODEL: 'MODEL',
	SERIAL: 'SERIAL',
	LOGISTIC: 'LOGISTIC',
	SERVICE: 'SERVICE',
}

/**
 * @typedef Request
 * @property { string } id
 * @property { string } status
 * @property { string } brand
 * @property { string } model
 * @property { string } serial
 * @property { array } logistic
 * @property { array } service
 */

export default applySpec({
	id: prop(Contract.ID),
	name: prop(Contract.NAME),
	status: prop(Contract.STATUS),
	brand: prop(Contract.BRAND),
	model: prop(Contract.MODEL),
	serial: prop(Contract.SERIAL),
	logistic: prop(Contract.LOGISTIC),
	service: prop(Contract.SERVICE),
});
